import React, { useState } from 'react'
import DatePicker from 'react-datepicker'
import { getMonth, getYear } from 'date-fns'
import { range } from 'lodash'
import "react-datepicker/dist/react-datepicker.css";

const DatePickerComp = ({ selectedDate, onChangeDate }) => {
    const [startDate, setStartDate] = useState(new Date(selectedDate));
    const years = range(1920, getYear(new Date()) + 1, 1);
    const onDateChanged = (date) => {
        onChangeDate(date);
        setStartDate(date);
    }
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    return (
        <DatePicker
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled
            }) => (
                    <div
                        style={{
                            margin: 10,
                            display: "flex",
                            justifyContent: "center",
                            width: '100%'
                        }}
                    >
                        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                            {"<"}
                        </button>
                        <select
                            value={getYear(date)}
                            onChange={({ target: { value } }) => changeYear(value)}
                        >
                            {years.map(option => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>

                        <select
                            value={months[getMonth(date)]}
                            onChange={({ target: { value } }) =>
                                changeMonth(months.indexOf(value))
                            }
                        >
                            {months.map(option => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>

                        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                            {">"}
                        </button>
                    </div>
                )}
            selected={startDate}
            onChange={date => onDateChanged(date)}
        />
    );
};

export default DatePickerComp